<template>
  <div>
    <router-view v-show="$route.matched.length == 3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length == 2">
      <div class="main-page-content">
        <el-row style="display: flex">
          <el-form size="medium" :inline="true" :model="searchCondition">
            <el-form-item label="时间">
              <DatePicker @dataSearch="dataSearch"/>
            </el-form-item>
            <el-form-item>
              <el-button @click="searchButton" style="color: #1890ff">查询</el-button>
            </el-form-item>
          </el-form>
          <!-- <el-select
            v-model="valueA"
            placeholder="请选择"
            class="application-wrapper"
            size="medium"
            @click="changeCompany"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="valueB"
            placeholder="请选择"
            class="application-wrapper"
            size="medium"
            @click="changeServiceCompany"
          >
            <el-option
              v-for="item in serviceOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select> -->
        </el-row>
        <el-row>
          <ScreeCompany @ScreeCompany="ScreeCompany"/>
        </el-row>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane v-for="(item, index) in this.tabsList" :label="item.label" :key="index" :name="item.name" class="tab-item">
          </el-tab-pane>
          <ApeTable
            ref="apeTable"
            :data="dataList"
            :columns="columns"
            :loading="loadingStaus"
            :pagingData="pagingData"
            highlight-current-row
            @switchPaging="switchPaging"
          >
            <el-table-column
              width="100"
              align="center"
              label="开票状态">
              <template slot-scope="scope">
               <div>{{ scope.row.alias_status }}</div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="驳回原因">
              <template slot-scope="scope">
               <div style="color: #f56c6c" >{{ scope.row.review_remark }}</div>
              </template>
            </el-table-column>
            <el-table-column
              width="300"
              align="left"
              label="操作"
            >
              <template slot-scope="scope">
                <span>
                  <el-button size="mini" type="primary" @click="toExamine(scope.row.id)" class="operation-btn" v-if="scope.row.alias_status == '审核中'">审核</el-button>
                </span>
                <span>
                  <el-button type="text" @click="viewApplyDetails(scope.row.id)" class="operation-btn" v-if="scope.row.alias_status == '驳回' || scope.row.alias_status == '开票中' || scope.row.alias_status == '复核中' || scope.row.alias_status == '复核通过' || scope.row.alias_status == '复核失败' || scope.row.alias_status == '发票寄出'">申请详情</el-button>
                  <el-button type="text" @click="viewBillDetails(scope.row.id)" class="operation-btn" v-if="scope.row.alias_status == '复核中' || scope.row.alias_status == '复核通过' || scope.row.alias_status == '复核失败' || scope.row.alias_status == '发票寄出'">开票详情</el-button>
                  <el-button type="text" @click="viewExpressInfo(scope.row.id)" class="operation-btn" v-if="scope.row.alias_status == '发票寄出'">快递详情</el-button>
                </span>
              </template>
            </el-table-column>
          </ApeTable>
        </el-tabs>
      </div>
      <!-- 查看开票详情 -->
      <ModalDialog :dialogData="invoiceDialogData" @dialogConfirm="invoiceHandleConfirm" @dialogClose="invoiceDialogClose" :showButton="showButton" :checkTitle="checkTitle">
        <template slot="content">
          <el-form :model="invoiceForm" ref="invoiceForm" class="demo-ruleForm" :label-position="'right'" >
            <el-form-item prop="invoiceNumber">
              <template slot="label">
                <div class="mail-title">数目：</div>
              </template>
              <span class="mail-content">{{ invoiceForm.invoiceNumber }}</span>
            </el-form-item>
            <el-form-item prop="invoice">
              <template slot="label">
                <div class="mail-title">发票：</div>
              </template>
            </el-form-item>
              <div v-for="(item, index) in invoiceForm.invoice" :key="index">
                <img :class="index != 0 ? 'new-mail-img' : 'mail-img'" :src="item"/>
              </div>
              <div v-if="invoiceForm.invoiceNumber > 1" @click="expendMore" class="expend">展开</div>
          </el-form>
        </template>
      </ModalDialog>
      <!-- 查看快递 -->
      <ModalDialog :dialogData="dialogData" @dialogConfirm="handleConfirm" @dialogClose="dialogClose" :showButton="showButton" :checkTitle="checkTitle">
        <template slot="content">
          <el-form :model="ruleForm" ref="ruleForm" class="demo-ruleForm" :label-position="'right'" >
            <el-form-item prop="expressName">
              <template slot="label">
                <div class="mail-title">快递名称：</div>
              </template>
              <span class="mail-content">{{ ruleForm.expressName }}</span>
            </el-form-item>
            <el-form-item prop="courierNumber">
              <template slot="label">
                <div class="mail-title">快递单号：</div>
              </template>
              <span class="mail-content">{{ ruleForm.courierNumber }}</span>
            </el-form-item>
            <!-- <el-form-item prop="invoice">
              <template slot="label">
                <div class="mail-title">快递图片：</div>
              </template>
            </el-form-item>
            <div v-for="(item, index) in ruleForm.invoice" :key="index">
              <img :class="index != 0 ? 'new-mail-img' : 'mail-img'" :src="item"/>
            </div>
            <div v-if="ruleForm.invoice.length > 1" @click="expendMore" class="expend">展开</div> -->
          </el-form>
        </template>
      </ModalDialog>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ModalDialog from '@/components/ModalDialog'
import ApeTable from "@/components/ApeTable";
import DatePicker from '@/components/DatePicker.vue'
import ScreeCompany from '@/components/ScreeCompany.vue'
export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    ModalDialog,
    DatePicker,
    ScreeCompany
  },
  watch: {
    "$route.matched": function(n, o) {
      console.log(o);
      if (n.length === 2) {
        this.init();
      }
    },
  },
  data() {
    return {
      ruleForm: {
        expressName: '',
        courierNumber: '',
        invoice: ''
      },
      invoiceForm: {
        invoiceNumber: '',
        invoice: ''
      },
      invoiceDialogData: {
        visible: false,
        title: '',
        width: '40%',
        loading: false,
        modal: false
      },
      dialogData:{
        visible: false,
        title: '发票查看',
        width: '40%',
        loading: false,
        modal: false
      },
      showButton: ['cancel'],
      checkTitle: '关闭',
      loadingStaus: false,
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      options: [
        {
          value: "北京筑帷科技有限公司",
          label: "北京筑帷科技有限公司",
        },
        {
          value: "北京筑帷科技有限公司1",
          label: "北京筑帷科技有限公司1",
        },
        {
          value: "北京筑帷科技有限公司2",
          label: "北京筑帷科技有限公司2",
        },
        {
          value: "北京筑帷科技有限公司3",
          label: "北京筑帷科技有限公司3",
        },
      ],
      serviceOptions: [
        {
          value: "河南科朗尼",
          label: "河南科朗尼",
        },
        {
          value: "河南科朗尼1",
          label: "河南科朗尼1",
        },
        {
          value: "河南科朗尼2",
          label: "河南科朗尼2",
        },
        {
          value: "河南科朗尼3",
          label: "河南科朗尼3",
        },
      ],
      valueA: "公司名称",
      valueB: '服务公司',
      tabsList: [
        {
          label: '全部',
          name: 'all'
        },
        {
          label: '审核中',
          name: 'toExamine'
        },
        {
          label: '驳回',
          name: 'refuse'
        },
        {
          label: '开票中',
          name: 'billing'
        },
        {
          label: '复核中',
          name: 'underReview'
        },
        {
          label: '复核通过',
          name: 'passThereview'
        },
        {
          label: '复核驳回',
          name: 'reviewRejected'
        },
        {
          label: '发票寄出',
          name: 'invoiceSent'
        }
      ],
      activeName: 'all',
      dataList: [],
      columns: [
        {
          title: "编号",
          value: "id",
          header_align: "center",
          align: "center",
        },
        {
          title: "申请开票时间",
          value: "created_at",
          header_align: "center",
          align: "center",
        },
        {
          title: "申请开票金额",
          value: "invoice_money",
          header_align: "center",
          align: "center",
        },
        {
          title: "开票公司",
          value: "company_name",
          header_align: "center",
          align: "center",
        },
        {
          title: "服务公司",
          value: "channel_name",
          header_align: "center",
          align: "center",
        },
      ],
      searchCondition:{
        time: '',
        status: '',
        invoice_status: '',
        company_id: '',
      },
    };
  },
  methods: {
    //分页
    switchPaging() {
      this.init()
    },
    // 搜索
    searchButton() {
      this.init('search')
    },
    ScreeCompany(v, name) {
      if (name == 'company') {
        if(v) {
          this.searchCondition.company_id = v
        } else {
          delete this.searchCondition.company_id
        }
        this.init('search')
      }

      if(name == 'settlement') {
        if (v) {
          this.searchCondition.channel_account = v
        } else {
          delete this.searchCondition.channel_account
        }
        this.init('search')
      }
    },
    //展开更多图片
    expendMore() {
      let node = document.getElementsByClassName("new-mail-img")
      for(let i = 0; i < node.length; i++) {
        node[i].style.display = 'block'
      }
      let expend = document.getElementsByClassName("expend")[0]
      expend.style.display = 'none'
    },
    //获取选中日期的值
    dataSearch(value) {
      this.searchCondition.time_value = value
    },
    //获取开票审核列表
    async init(type) {
      if(type) {
        this.mxResetPage()
      }
      this.loadingStaus=true
      let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
      if(type == 'search') {
        pagingInfo.current_page = 1
      }
      let searchCondition = this.handleSearchCondition()
      if(searchCondition.sign_type == 'all') {
        delete searchCondition.sign_type
      }
      Object.assign(searchCondition,pagingInfo)
      let {list,pages}= await this.$api.getInvoiceAuditList(searchCondition)
      this.$nextTick(() => {
        this.dataList=list
      })
      this.pagingData.total = pages.total
      this.offset = pages.offset
      this.loadingStaus=false
    },
    // 选择公司
    changeCompany(e) {
      console.log(e,"公司")
      this.searchCondition.company = e
    },
    // 选择服务公司
    changeServiceCompany(e) {
      console.log(e,"服务公司")
      this.searchCondition.serviceCompany = e
    },
    //点击tab切换
    async handleClick(tab) {
      if (tab.name == 'all') { // 全部
        delete this.searchCondition.status
        delete this.searchCondition.invoice_status
        this.init('all')
      } else if(tab.name == 'toExamine') {  // 审核中
        this.searchCondition.status = 1
        delete this.searchCondition.invoice_status
        this.init('toExamine')
      } else if(tab.name == 'refuse') {  // 驳回
        this.searchCondition.status = 3
        delete this.searchCondition.invoice_status
        this.init('refuse')
      } else if(tab.name == 'billing') {  // 开票中
        this.searchCondition.status = 2
        this.searchCondition.invoice_status = 1
        console.log("billing",this.searchCondition.status,this.searchCondition.invoice_status)
        this.init('billing')
      } else if(tab.name == 'underReview') {  // 复核中
        this.searchCondition.status = 2
        this.searchCondition.invoice_status = 2
        this.init('underReview')
      }else if(tab.name == 'passThereview') {  // 复核通过
        this.searchCondition.status = 2
        this.searchCondition.invoice_status = 3
        this.init('passThereview')
      }else if(tab.name == 'reviewRejected') {  // 复核驳回
        this.searchCondition.status = 2
        this.searchCondition.invoice_status = 5
        this.init('reviewRejected')
      } else if(tab.name == 'invoiceSent') {  // 发票寄出
        this.searchCondition.status = 2
        this.searchCondition.invoice_status = 4
        this.init('invoiceSent')
      }
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {}
      if (this.searchCondition.status === 0 || this.searchCondition.status) {
        condition.status = this.searchCondition.status
      }
      if (this.searchCondition.invoice_status === 0 || this.searchCondition.invoice_status) {
        condition.invoice_status = this.searchCondition.invoice_status
      }
      if (this.searchCondition.time_value) {
        condition.time = {
          start_time: this.searchCondition.time_value[0],
          end_time: this.searchCondition.time_value[1],
        }
      }
      if(this.searchCondition.company_id) {
        condition.company_id = this.searchCondition.company_id
      }
      if(this.searchCondition.channel_account){
        condition.channel_account = this.searchCondition.channel_account
      }
      return condition
    },
    //处理发票模态框，确定事件
    invoiceHandleConfirm() {
      this.invoiceForm = {}
      this.invoiceDialogData.visible = false
    },
    //处理发票模态框，关闭事件
    invoiceDialogClose() {
      this.invoiceForm = {}
      this.invoiceDialogData.visible = false
    },

    //查看快递详情
    async viewExpressInfo(id) {
      this.dialogData.loading = false
      this.dialogData.visible = true
      this.dialogData.title = `快递信息查看${id}`
      this.checkTitle = '关闭'
      let args = {id: id}
      let result = await this.$api.invoiceAuditExpressDetails(args)
      if(result) {
        this.ruleForm = {
          expressName: '顺丰',
          courierNumber: result.express_no,
          invoice: result.express_img.split(",")
        }
      }
    },
    // 审核
    toExamine(id) {
      console.log(id)
      this.$router.push({path: '/admin_invoice/detail', query: {id: id, title: '开票审核', isExamine: true}})
    },
    //查看开票详情
    async viewBillDetails(id) {
      this.invoiceDialogData .title = `发票${id}`
      this.invoiceDialogData.visible = true
      this.checkTitle = '关闭'
      let args = {
        id: id
      }
      let result = await this.$api.invoiceAuditDetail(args)
      console.log(result)
      if(result) {
        this.invoiceForm = {
          invoiceNumber: result.invoice_img_num,
          invoice: result.invoice_imgs
        }
      }
    },
    //查看申请详情
    viewApplyDetails(id) {
      this.$router.push({path: '/admin_invoice/detail', query: {id: id, title: '开票审核'}})
    },
    // 处理模态框，确定事件
    handleConfirm() {
      // 调用组件的数据验证方法
      this.dialogData.visible = false
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.dialogData.visible = false
      this.dialogData.loading = true
    },
  },
  mounted() {
    this.init()
  },
};
</script>

<style lang="stylus" scoped>
.el-button
  margin-right 4px
  margin-bottom 4px
.operation-btn
  margin: 0 20px
.el-button + .el-button
  margin-left: 0
.item-info {
  display: flex;
  flex-direction: row;
}

.item-info-left {
  width: 130px;
  height: 130px;
}

.item-info-right {
  width: 200px;
  padding: 15px;
  line-height: 40px;
}

.item-info-title {
  color: #aeaeb2;
  font-size: 18px;
}

.item-info-price {
  color: #101010;
  font-size: 28px;
}

.item-info-progress {
  width: 76px;
  height: 11px;
  border: 1px solid black;
}

.border-right {
  border-right: 2px solid #BBBBBB;
}

.application-wrapper {
  width: 280px;
  margin-left: 30px;
}
.new-mail-img {
  display: none
  width: 100%
}
.invoice-img {
  width: 100%
  height: 300px
  border: 1px solid black
}
.mail-title
  color: rgba(16, 16, 16, 100)
  font-size: 16px
.mail-content
  color: rgba(16, 16, 16, 100)
  font-size: 16px
.mail-img
  width: 100%
.expend
  text-align: center
  margin-top: 20px
  color: #333
</style>






